/* ======================================================================== */
/* 4. PJAX Init New Page */
/* ======================================================================== */
function PJAXInitNewPage(data) {

	return new Promise(function (resolve, reject) {

		Promise.all([
			PJAXUpdateAdminBar(data),
			PJAXUpdateLanguageSwitcher(data),
			PJAXUpdateBodyClasses(data),
			PJAXUpdateHeaderClasses(data),
			PJAXUpdateHead(data),
		]).then(function () {

			var
				tl = new TimelineMax(),
				$nextContainer = $(data.next.container);

			tl
				.add(function () {

					// re-init Contact Form 7
					if (typeof wpcf7 !== 'undefined') {
						wpcf7.initForm(jQuery('.wpcf7-form'));
					}

					// clear & re-init ScrollMagic
					window.SMController.destroy(true);
					window.SMController = new ScrollMagic.Controller();

					// split text lines in new container
					doSplitText($nextContainer).then(setLines($nextContainer)).then(function () {

						// scroll to the top
						setTimeout(function () {
							scrollToVeryTop();
						}, 100);

						if (typeof window.elementorFrontend !== 'undefined') {
							elementorFrontend.init();
						}

						// re-init components
						initComponents($nextContainer);
						window.SMController.enabled(false);

						// update ad trackers
						PJAXUpdateTrackers();

					});

					// change header color if needed
					switch (data.next.namespace) {
						case 'light': {
							window.$header.removeClass('header_white').addClass('header_black');
							break;
						}
						case 'dark': {
							window.$header.removeClass('header_black').addClass('header_white');
							break;
						}
					}

					$nextContainer.removeClass('page-wrapper_hidden');

				})
				.add(function () {
					resolve(true);
				});

		});
	});

}
